import React from "react";
import PdfParameterProgressBar from "./PdfParameterProgressBar";

export default function PdfConsistencyAnalysis({ score }) {
  return (
    <div className={"mb-1"}>
      <h5 className={"text-color-gray-dark"}> Tutarlılık ve Yönelme Analizi</h5>
      <PdfParameterProgressBar name="Tutarlılık Skoru" score={score} />
    </div>
  );
}
